export enum Role{
    Unknown = -1,
    User = 1,
    Administrator = 2,
    SuperAdmin = 3
}

export enum LogInState{
    AppLoading = -1,
    NotLoggedIn,
    TokenExpired,
    LoggedIn
}

export enum ConnectionStatus{
    NoAttempts,
    Connecting,
    Connected,
    TestingToken,
    TokenTested,
    NoConnection
}


export type VerifyTokenResp = { success: boolean, token_active: boolean, role?: Role, user_id?: number, errorCode?: number };
export type LoginResp = { success: boolean, dfs_token_active: boolean, user_id: number, role: Role, errorCode?: number };
export type SignUpResp = { success: boolean, username: string|undefined, errorCode?: number };
